<template>
  <v-navigation-drawer
    style="top: 0px; max-height:100vh!important;"
    right
    v-model="internalOpen"
    :clipped="$vuetify.breakpoint.lgAndUp"
    app
  >
    <v-container class="ma-0 pa-0 pb-8">
      <v-row class="pt-8 px-6 ma-0 pb-12">

        <strong>Filtros</strong>
        <v-spacer></v-spacer>
        <v-btn @click="onClear" small class="elevation-0" style="border:solid 1px #dddddd;">
          <v-icon small class="mr-1">mdi-filter-off</v-icon>Limpiar
        </v-btn>

        <v-text-field label="Folio" v-model="localFilters.id"></v-text-field>

        <!-- Influencer (autocomplete: guarda solo ID) -->
        <v-autocomplete
          class="mt-4"
          v-model="influencerModel"
          :items="entriesInfluencers"
          :loading="isLoadingInfluencers"
          :search-input.sync="influencerSearch"
          :filter="() => true"
          return-object
          item-text="__label"
          item-value="id"
          label="Influencer"
          prepend-inner-icon="mdi-account-search"
          clearable
        >
          <template v-slot:item="{ item, on, attrs }">
            <v-list-item v-on="on" v-bind="attrs">
              <v-list-item-avatar v-if="item.avatar" size="28">
                <img :src="item.avatar" alt="">
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>{{ item.__label }}</v-list-item-title>
                <v-list-item-subtitle v-if="item.handle">{{ item.handle }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-autocomplete>

        <!-- Provider -->
        <v-select class="mt-2" label="Tipo" :items="providers" item-text="text" item-value="value" v-model="localFilters.provider" clearable />

        <!-- Type -->
        <v-select class="mt-2" label="Tipo Media" :items="types" v-model="localFilters.type" clearable />


        <v-autocomplete
        class="mt-2"
        v-model="categoryModel"
        :items="categories"
        item-text="name"
        item-value="id"
        label="Categorías"
        multiple
        chips
        small-chips
        clearable
        :loading="catLoading"
        :search-input.sync="categorySearch"
        :filter="() => true"
        return-object
        :value-comparator="(a,b) => (+((a&&a.id)!=null?a.id:a) === +((b&&b.id)!=null?b.id:b))"
        @change="syncCategoryIds"
        >
          <template v-slot:selection="data">
            <v-chip
              v-bind="data.attrs"
              :input-value="data.selected"
              close
              @click="data.select"
              @click:close="removeCategoryChip(data.item)"
              small
            >
              {{ data.item.name }}
            </v-chip>
          </template>
        </v-autocomplete>

        <!-- Fecha publicación -->
        <v-menu
          v-model="menuDate"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field v-on="on" readonly label="Fecha publicación" :value="localFilters.published_at" />
          </template>
          <v-date-picker v-model="localFilters.published_at" @input="menuDate=false"/>
        </v-menu>

        
      </v-row>

      <v-card style="position:absolute; bottom:0; width:100%;" tile color="primary">
          <v-list-item link @click="onApply" dark>
            <v-list-item-content>
              <strong>Filtrar</strong>
            </v-list-item-content>
          </v-list-item>
        </v-card>
    </v-container>
  </v-navigation-drawer>
</template>

<script>
import axios from 'axios'

export default {
  name: 'RosterFilters',
  props: {
    value: { type: Boolean, default: false },              // drawer open
    filters: {
      type: Object,
      default: () => ({
        id:'',
        influencer_id: '',
        provider: null,
        type: null,
        category_ids: [], // array de números
        published_at: '',
      })
    },
    providers: { type: Array, default: () => [] },
    types: { type: Array, default: () => [] },
    currentUser: { type: Object, default: null },
  },
  data: () => ({
    internalOpen: false,

    localFilters: {
      influencer_id: '',
      id:'',
      provider: null,
      type: null,
      category_ids: [],
      published_at: '',
    },

    // influencer autocomplete
    influencerModel: null,
    entriesInfluencers: [],
    influencerSearch: '',
    isLoadingInfluencers: false,
    _influencerDebounce: null,

    // categories autocomplete
    categories: [],
    catLoading: false,
    categoryModel: [],
    categorySearch: '',
    _catDebounce: null,

    menuDate: false,
  }),
  watch: {
    value: {
      immediate: true,
      handler (v) { this.internalOpen = v }
    },
    internalOpen (v) {
      this.$emit('input', v)
      this.$emit('update:value', v)
    },

    // refleja props.filters -> localFilters y modelos visuales
    filters: {
      immediate: true,
      deep: true,
      handler (val) {
        const f = val || {}
        this.localFilters = {
          influencer_id: f.influencer_id || '',
          id: f.id || '',
          provider: f.provider || null,
          type: f.type || null,
          category_ids: Array.isArray(f.category_ids) ? [...f.category_ids] : [],
          published_at: f.published_at || '',
        }
        // hidratar modelos visuales si tenemos datos
        this.hydrateInfluencerFromId(f.influencer_id)
        this.hydrateCategoriesFromIds(this.localFilters.category_ids)
      }
    },

    // influencer search debounce
    influencerSearch (val) {
      if (this._influencerDebounce) clearTimeout(this._influencerDebounce)
      this._influencerDebounce = setTimeout(() => {
        this.searchInfluencers(val)
      }, 300)
    },

    // categories search debounce
    categorySearch (val) {
      if (this._catDebounce) clearTimeout(this._catDebounce)
      this._catDebounce = setTimeout(() => {
        this.fetchCategories(val)
      }, 300)
    },

    // sincroniza id en filtros cuando cambia el modelo visual
    influencerModel (val) {
      this.localFilters.influencer_id = val && val.id ? (Number(val.id) || val.id) : ''
    },

    // ⚠️ FIX: sincronizar SIEMPRE categoryModel -> localFilters.category_ids
    categoryModel: {
      deep: true,
      handler () {
        this.syncCategoryIds()
      }
    },
  },
  mounted () {
    // carga inicial de catálogos
    this.fetchCategories()
  },
  methods: {
    // ===== Apply / Clear =====
    onApply () {
      // devuelve filtros limpios al padre
      this.$emit('update:filters', { ...this.localFilters })
      this.$emit('apply')
    },
    onClear () {
      this.influencerModel = null
      this.influencerSearch = ''
      this.categoryModel = []
      this.categorySearch = ''
      this.localFilters = {
        id:'',
        influencer_id: '',
        provider: null,
        type: null,
        category_ids: [],
        published_at: '',
      }
      this.$emit('update:filters', { ...this.localFilters })
      this.$emit('clear')
    },

    // ===== Influencers =====
    normalizeInfluencer(raw){
      const id = raw.id
      const name =
        raw.name ||
        raw.full_name ||
        `${raw.first_name || ''} ${raw.last_name || ''}`.trim() ||
        (raw.social_networks && raw.social_networks.instagram) ||
        `#${id}`
      const handle =
        (raw.social_networks && (raw.social_networks.instagram || raw.social_networks.tiktok)) ||
        raw.handle ||
        ''
      const avatar = raw.profile_photo_path
        ? (raw.profile_photo_path.startsWith('http')
            ? raw.profile_photo_path
            : null)
        : null
      return { id, __label: name, handle, avatar }
    },

    async searchInfluencers(val){
      const q = (val == null ? '' : String(val)).trim()
      if(this.influencerModel!=null){return}
      if (q === '' && this.influencerModel=='') {
        // limpiar items si no hay búsqueda
        this.entriesInfluencers = []
        return
      }
      if (this.isLoadingInfluencers) return
      this.isLoadingInfluencers = true

      try{
        // limpiar SIEMPRE antes de cargar nuevos resultados
        this.entriesInfluencers = []

        let extra = ''
        if (this.currentUser && (this.currentUser.role === 'Talent Agent' || this.currentUser.role === 'Booking')) {
          extra = `&filter[parent_id]=${this.currentUser.id}`
        }
        const url =
          `${process.env.VUE_APP_BACKEND_ROUTE}api/v1/influencer/search?filter[social_networks]=${encodeURIComponent(q)}${extra}`

        const res = await axios.get(url)
        const list = Array.isArray(res.data?.data) ? res.data.data : (res.data || [])
        // Rellenar SOLO con la respuesta del servidor
        this.entriesInfluencers = list.map(this.normalizeInfluencer)
      } finally {
        this.isLoadingInfluencers = false
      }
    },

    // Si viene un influencer_id en filtros, intenta hidratar el modelo (opcional)
    async hydrateInfluencerFromId (id) {
      if (!id) { this.influencerModel = null; return }
      // No llamamos API extra; solo mostramos chip si ya está en lista, si no, lo dejamos mínimo.
      const found = this.entriesInfluencers.find(x => `${x.id}` === `${id}`)
      if (found) {
        this.influencerModel = found
      } else {
        // modelo mínimo
        this.influencerModel = { id, __label: `#${id}`, handle: '', avatar: null }
      }
    },

    // ===== Categorías =====
    async fetchCategories (name = '') {
      try {
        this.catLoading = true
        const params = {}
        if (name && name.trim().length >= 2) {
          params['name'] = name.trim()
        }
        const { data } = await axios.get(`${process.env.VUE_APP_BACKEND_ROUTE}api/v1/categories`, { params })
        const list = Array.isArray(data?.data) ? data.data : data

        // normaliza y dedup por id
        const map = new Map()
        for (const c of list) {
          const item = { id: +c.id, name: c.name, type: c.type || null }
          map.set(item.id, item)
        }
        this.categories = Array.from(map.values())

        // rehidrata selección si había ids
        this.hydrateCategoriesFromIds(this.localFilters.category_ids)
      } finally {
        this.catLoading = false
      }
    },

    hydrateCategoriesFromIds (ids = []) {
      if (!Array.isArray(ids)) ids = []
      const map = new Map(this.categories.map(c => [ +c.id, c ]))
      this.categoryModel = ids
        .map(id => map.get(+id) || { id: +id, name: `#${id}` })
    },

    // refleja SIEMPRE los ids seleccionados en localFilters.category_ids
    syncCategoryIds () {
        const ids = (this.categoryModel || [])
            .map(c => typeof c === 'object' && c !== null ? +c.id : +c)
            .filter(n => Number.isFinite(n))
        this.localFilters.category_ids = Array.from(new Set(ids))
    },

    removeCategoryChip (item) {
      const id = +item.id
      this.categoryModel = this.categoryModel.filter(c => +c.id !== id)
      this.syncCategoryIds()
    },
  }
}
</script>
